import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import index from "@/page/index";

import country from "@/page/product/country";
import detail from "@/page/product/detail";
import generate from "@/page/generate/generate";
import privacy from "@/page/privacy/privacy";
import news from "@/page/news/news";
import newsdetails from "@/page/news/newsdetails";
import contactus from "@/page/contactus/contactus";
import aboutus from "@/page/aboutus/aboutus";
import visanotice from "@/page/visanotice/visanotice";
import create from "@/page/product/create";
import orderpay from "@/page/product/orderpay";
import personcenter from "@/page/personcenter/personcenter";
import Insurance from "@/page/Insurance/index";
import productDetile from "@/page/Insurance/productDetile";
import form from "@/page/Insurance/form";
import InsuranceDetail from "@/page/Insurance/InsuranceDetail";
import orderlist from "@/page/product/orderlist";
import h5 from "@/page/h5/index";
import activity from "@/page/index/activity";

const originalPush = Router.prototype.push;
//解决报错信息：NavigationDuplicated: Avoided redundant navigation to current location
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        title: "首页" // 标题设置
      }
    },
		{
		  path: "/activity",
		  name: "activity",
		  component: activity,
		  meta: {
		    title: "虎翼掌上签" // 标题设置
		  }
		},
    {
      path: "/country",
      name: "country",
      component: country,
      meta: {
        title: "签证国家" // 标题设置
      }
    },
    {
      path: "/detail",
      name: "detail",
      component: detail,
      // component:() => import('@/page/product/detail'),
      meta: {
        title: "签证国家" // 标题设置
      }
    },
    {
      path: "/create",
      name: "create",
      component: create,
      meta: {
        title: "创建订单" // 标题设置
      }
    },
    {
      path: "/orderpay",
      name: "orderpay",
      component: orderpay,
      meta: {
        title: "订单支付" // 标题设置
      }
    },
    {
      path: "/orderlist",
      name: "orderlist",
      component: orderlist,
      meta: {
        title: "订单列表" // 标题设置
      }
    },
    {
      path: "/personcenter",
      name: "personcenter",
      component: personcenter,
      meta: {
        title: "个人中心"
      }
    },
    {
      path: "/index",
      name: "index",
      component: index,
      meta: {
        title: "首页" // 标题设置
      }
    },
    {
      path: "/generate",
      name: "generate",
      component: generate,
      meta: {
        title: "签证工具"
      }
    },
    {
      path: "/Insurance",
      name: "Insurance",
      component: Insurance,
      meta: {
        title: "保险商城"
      }
    },
    {
      path: "/productDetile",
      name: "productDetile",
      component: productDetile,
      meta: {
        title: "保险详情"
      }
    },
    {
      path: "/InsuranceDetail",
      name: "InsuranceDetail",
      component: InsuranceDetail,
      meta: {
        title: "保险详情"
      }
    },
    {
      path: "/form",
      name: "form",
      component: form,
      meta: {
        title: "投保"
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
      meta: {
        title: "隐私政策" // 标题设置
      }
    },
    {
      path: "/news",
      name: "news",
      component: news,
      meta: {
        title: "签证资讯" // 标题设置
      }
    },
    {
      path: "/newsdetails",
      name: "newsdetails",
      component: newsdetails,
      meta: {
        title: "资讯详情" // 标题设置
      }
    },
    {
      path: "/contactus",
      name: "contactus",
      component: contactus,
      meta: {
        title: "联系我们" // 标题设置
      }
    },
    {
      path: "/aboutus",
      name: "aboutus",
      component: aboutus,
      meta: {
        title: "关于我们" // 标题设置
      }
    },
    {
      path: "/visanotice",
      name: "visanotice",
      component: visanotice,
      meta: {
        title: "签证须知" // 标题设置
      }
    },
    {
      path: "/h5",
      name: "h5",
      component: h5,
      meta: {
        title: "提交资料" // 标题设置
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js